import { Button, Form, Input, Table, message } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { fetchCountries } from "./FetchCountries";
import { EditOutlined } from "@ant-design/icons";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { create_country, update_country } from "../../endpoints/API";

const Country = () => {
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);
  const [countries, setCountries] = useState([]); // State to store country data
  const isUser = useSelector((state) => state.user.user); // Fetch user data from Redux
  const [form] = Form.useForm(); // Create form instance
  const [editingCountryId, setEditingCountryId] = useState(null); // Track editing country ID

  useEffect(() => {
    fetchCountries(setCountries, baseUrl, prodTestUrl); // Call the fetch function on mount
  }, []); // Empty dependency array to run only on mount

  const onFinish = async (values) => {
    try {
      const payload = {
        country: values.country.trim(),
        id : editingCountryId?editingCountryId:undefined,
        created_by: isUser.user_id,
      };

      let response;

      if (editingCountryId) {
        response = await update_country(payload);
      } else {
        response = await create_country(payload);
      }

      if (response.statusText=="OK") {
        const data = response?.data;

        // Show success message
        message.success(
          editingCountryId
            ? "Country updated successfully!"
            : "Country created successfully!"
        );

        // Fetch updated list of countries
        fetchCountries(setCountries, baseUrl, prodTestUrl); // Call fetchCountries again to refresh the list

        // Reset form fields
        form.resetFields(); // Reset input field after successful operation
        setEditingCountryId(null); // Clear editing ID after successful operation
      } else {
        const errorData = await response.json();
        message.error(errorData.error || "An error occurred.");
      }
    } catch (error) {
      message.error(error?.response?.data?.error||"An error occurred while processing the request.");
    }
  };

  const handleEdit = (country) => {
    form.setFieldsValue({ country: country.name }); // Set the form field with the country name
    setEditingCountryId(country.id); // Set the ID of the country to edit
  };

  const columns = [
    {
      title: "Country",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
      render: (_, country) => (
        <Button onClick={() => handleEdit(country)}>
          <EditOutlined />
        </Button>
      ), // Render the Edit button
    },
  ];

  return (
    <div>
      <Form form={form} onFinish={onFinish}>
        <div
          className="border flex gap-5 p-4 items-center rounded-lg shadow-md"
          style={{ padding: "16px" }}
        >
          <Form.Item
            label={<span className="font-semibold">Add Country</span>}
            name="country"
            rules={[{ required: true, message: "Please enter a country!" }]}
            style={{ margin: "0" }} // Reset margin for Form.Item
          >
            <Input placeholder="Enter Country" style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item style={{ margin: "0" }}>
            <Button type="primary" htmlType="submit">
              {editingCountryId ? "Update" : "Save"}{" "}
              {/* Change button text based on editing state */}
            </Button>
          </Form.Item>
        </div>
      </Form>

      <Table
        dataSource={countries} // Set dataSource to the countries state
        columns={columns}
        rowKey="id" // Use ID as the unique key for rows
      />
    </div>
  );
};

export default Country;
